const state = {
    messages: []
};

const mutations = {
    setMessages(state, data) {
        state.messages = data;
    }
};
const actions = {
    getMessages(context) {
        this.service.get('/getMess');
        context.commit('setMessages', [
            { id: 1, text: '电子烟雾话区域温度注意事项' },
            { id: 2, text: '电子烟雾话区域温度注意事项' },
            { id: 3, text: '电子烟雾话区域温度注意事项' }
        ]);
    }
};

const getters = {};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
